import { faBarsFilter } from "@fortawesome/pro-solid-svg-icons/faBarsFilter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton, IconButtonProps } from "@mui/material";
import { useMprcTheme } from "components/MprcThemeProvider";
import * as React from "react";

interface IProps {
    filtered: boolean;
}

type Props = IProps & IconButtonProps;

export const MprcFilterIconButton: React.FC<Props> = (props) => {
    const { theme } = useMprcTheme();
    const { filtered, color, onClick, title, ...rest } = props;

    const lTitle = title || theme.iconButtons.IconButtonFilter.title;
    return (
        <IconButton
            {...rest}
            title={lTitle}
            color={filtered ? "warning" : color ?? "inherit"}
            disableRipple={onClick == null}
            disableFocusRipple={onClick == null}
            onClick={onClick}
        >
            <FontAwesomeIcon icon={faBarsFilter} />
        </IconButton>
    );
};
